import { computed } from "vue";
import { defineStore } from "pinia";
import { useHighlightsField } from "./lib/useHighlightsField";
import { useIsCurrentExperienceOpinoia } from "@/features/experience-shared/composables/useIsCurrentExperienceOpinoia";

export const useCurationIncluded = defineStore("curation-content-included-field", () => {
  const field = useHighlightsField({
    id: "included",
    fieldKey: "included",
    masterDataStoreKey: "included",
    searchPlaceholderKey: "experience.premade.search.inclusions",
  });

  const isOpinoiaExperience = useIsCurrentExperienceOpinoia();
  const isRequired = computed(() => field.isRequired && !isOpinoiaExperience.value);

  return {
    ...field,
    isRequired,
  };
});
